import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';
import every from 'lodash/every';

import { selectTextListData } from '../../../../utils';
import SplitContentContainer from '../SplitContentContainer/SplitContentContainer';
import SRLStudentResponses from '../SRLStudentResponses/SRLStudentResponses';
import AveragesIntroList from './AveragesIntroList';
import LowerAverageAndGradesChart from './LowerAverageAndGradesChart';
import ExpectiationScaleChart from './ExpectiationScaleChart';
import {
  getPromptAlias,
  selectIntroAveragesData,
  getLowerThanExpectedPercentage,
  getGradeRange,
  getExpectationScale,
} from './helper';

function SRLAcademicContent({ data, isMobileXS }) {
  const { insightsData, isSRLIntroSurvey } = data;

  let rightColumnContent = null;
  let leftColumnContent = null;
  if (isSRLIntroSurvey) {
    const { prompt, studentResponses } = selectTextListData(insightsData);
    const hasStudentResponses = studentResponses.length > 0;
    if (hasStudentResponses) {
      const promptAlias = getPromptAlias(prompt);
      rightColumnContent = (
        <SRLStudentResponses
          prompt={promptAlias}
          studentResponses={studentResponses}
          responseLimit={2}
          lineLimit={4}
        />
      );
    }
    const averagesData = selectIntroAveragesData(insightsData);
    const isEmptyAverages =
      averagesData.length === 0 ||
      every(averagesData, (item) => isNil(item.percent));
    if (!isEmptyAverages) {
      leftColumnContent = (
        <AveragesIntroList
          averages={averagesData}
          isFullWidth={!hasStudentResponses}
        />
      );
    }
  } else {
    const lowerThanExpectedPercentage =
      getLowerThanExpectedPercentage(insightsData);
    const gradeRanges = getGradeRange(insightsData);
    const expectationScale = getExpectationScale(insightsData);

    if (expectationScale.length && gradeRanges.length) {
      leftColumnContent = (
        <LowerAverageAndGradesChart
          chartData={gradeRanges}
          lowerThanExpectedPercentage={lowerThanExpectedPercentage}
        />
      );

      rightColumnContent = (
        <ExpectiationScaleChart
          chartData={expectationScale}
          isMobileXS={isMobileXS}
        />
      );
    }

    if (gradeRanges && expectationScale.length === 0) {
      leftColumnContent = (
        <LowerAverageAndGradesChart chartData={gradeRanges} />
      );
    }

    if (expectationScale.length && gradeRanges.length === 0) {
      leftColumnContent = (
        <LowerAverageAndGradesChart
          lowerThanExpectedPercentage={lowerThanExpectedPercentage}
        />
      );

      rightColumnContent = (
        <ExpectiationScaleChart
          chartData={expectationScale}
          isMobileXS={isMobileXS}
        />
      );
    }
  }

  return (
    <SplitContentContainer
      leftColumnContent={leftColumnContent}
      rightColumnContent={rightColumnContent}
      borderPosition={isSRLIntroSurvey && !isMobileXS ? 'center' : 'left'}
      stackedVersion={isMobileXS}
    />
  );
}

SRLAcademicContent.propTypes = {
  data: PropTypes.shape({
    insightsData: PropTypes.array.isRequired,
    isSRLIntroSurvey: PropTypes.bool,
  }),
  isMobileXS: PropTypes.bool,
};

export default SRLAcademicContent;
